import type { Snack } from "@kaleidoscope-solutions/ks-design-system"

import { computed, readonly, ref } from "vue"

type SnackType = `${Snack}`
export interface Snackbar {
  type: SnackType
  message: string
}

const snacks = ref<Snackbar[]>([])

export function useSnackbar() {
  const addSnackbar = (snack: Snackbar) => {
    snacks.value.push(snack)

    setTimeout(() => snacks.value.shift(), 6000)
  }

  const hasSnacks = computed(() => snacks.value.length > 0)

  return {
    snacks: readonly(snacks.value),
    addSnackbar,
    hasSnacks,
  }
}
